import { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import Hero from '../../components/hero/Hero';
import Demos from '../../components/Demos/Demos';
import CtaSection from '../../components/CtaSection/CtaSection';
import FeaturesSection from '../../components/Features/Features';
import FooterSection from '../../components/Footer/FooterSection';
import Scrollbar from '../../components/scrollbar/scrollbar'
import AwesomeFeatures from '../../components/AwesomeFeatures/AwesomeFeatures';



const HomePage = () => {

    return (
        <Fragment>
            <Navbar />
            <Hero />
            <Demos />
            <CtaSection />
            <FeaturesSection />
            <AwesomeFeatures />
            <FooterSection />
            <Scrollbar />
        </Fragment>
    )
};

export default HomePage;